import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { FAQS } from '../data/seoContent';

export const faqJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: FAQS.map((f) => ({ '@type': 'Question', name: f.q, acceptedAnswer: { '@type': 'Answer', text: f.a } })),
};

const FaqItem = ({ f, i }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="border-b border-[#0E3D95]/10">
      <button onClick={() => setOpen(!open)} className="w-full flex items-center justify-between gap-4 py-5 text-left" data-testid={`faq-question-${i}`} aria-expanded={open}>
        <h3 className="font-semibold text-[#0E3D95] text-base md:text-lg">{f.q}</h3>
        <ChevronDown className={`shrink-0 text-[#F88200] transition-transform duration-300 ${open ? 'rotate-180' : ''}`} />
      </button>
      {/* Answer stays in the DOM so search engines and AI assistants can read it */}
      <p className={`text-slate-600 pr-8 overflow-hidden transition-[max-height,padding] duration-300 ${open ? 'max-h-60 pb-5' : 'max-h-0'}`} data-testid={`faq-answer-${i}`}>{f.a}</p>
    </div>
  );
};

export const FaqSection = ({ heading = 'Frequently Asked Questions', limit }) => (
  <section className="py-16 md:py-20 bg-white" data-testid="faq-section">
    <div className="max-w-4xl mx-auto px-4">
      <p className="text-sm font-semibold uppercase tracking-wider text-[#F88200] mb-2">FAQ</p>
      <h2 className="font-['Barlow_Condensed'] text-3xl md:text-5xl font-bold uppercase text-[#0E3D95] mb-6">{heading}</h2>
      {(limit ? FAQS.slice(0, limit) : FAQS).map((f, i) => <FaqItem key={f.q} f={f} i={i} />)}
    </div>
  </section>
);

export default FaqSection;
